"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWithNotification = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const constants_1 = require("../../constants");
const core_1 = require("../../core");
require("./types");
const ButtonWithNotification = ({ isLoading, isDone, isModified, isDisabled, texts, onClick, }) => {
    const { t } = core_1.useFeatureContext();
    const showMessage = (isDone && !isModified) || (!isLoading && isModified);
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center, gap: components_1.STACK_GAP.s },
        react_1.default.createElement(components_1.Button, { ui: components_1.BUTTON_VIEW.primary, disabled: isDisabled || isLoading || !isModified, style: { minWidth: 80 }, onClick: () => {
                onClick();
            } }, (texts === null || texts === void 0 ? void 0 : texts.control) || t('buttonWithNotification|actions|done|label')),
        isLoading ? react_1.default.createElement(components_1.Spinner, { size: constants_1.SPINNER_SIZES.l }) : '',
        !isLoading && showMessage && (react_1.default.createElement(components_1.Notification, { status: isModified ? components_1.NOTIFICATION_STATUS.info : components_1.NOTIFICATION_STATUS.ok }, isModified
            ? (texts === null || texts === void 0 ? void 0 : texts.modify) || t('buttonWithNotification|notifications|modify|label')
            : (texts === null || texts === void 0 ? void 0 : texts.done) || t('buttonWithNotification|notifications|done|label')))));
};
exports.ButtonWithNotification = ButtonWithNotification;
//# sourceMappingURL=ButtonWithNotification.js.map